import React, { useState, useContext, useEffect } from 'react'
import { Navigate } from 'react-router-dom';
import { Form, Button, Flag } from 'semantic-ui-react'
import { isMobile } from 'react-device-detect';
import GlobalContext from '../../../contexts/GlobalContext';
import API, { ResponseManagement, ErrorManagement } from '../../../API';
import InputText from '../../FormInputCustomer/InputText/InputText';
import InputSelect from '../../FormInputCustomer/InputSelect/InputSelect';
import Utility from '../../../Utility';
import { toast } from 'react-toastify';
import { SET_USER } from '../../../contexts/GlobalType';
import 'react-toastify/dist/ReactToastify.css';
import './FormAddressCP.css';

const FormAddressCP = (props) => {
  const [globalContext, dispatch] = useContext(GlobalContext);
  const [redirectState, setRedirectState] = useState(false);
  const [errorState, setErrorState] = useState({});
  const [firstAddressState, setFirstAddressState] = useState('');
  const [secondaryAddressState, setSecondaryAddressState] = useState('');
  const [thirdAddressState, setThirdAddressState] = useState('');
  const [zipCodeState, setZipCodeState] = useState('');
  const [cityState, setCityState] = useState('');
  const [countryState, setCountryState] = useState('');

  //console.log("FormAddressCP")
  useEffect(() => {
    let listInput = getInput();
    let listState = {
      redirect: false,
      error: {}
    };
    
    for (let index in listInput) {// eslint-disable-line no-unused-vars
      let input = listInput[index];
      listState[input.name] = input.valueDefault;
      listState.error[input.name] = false;
    }
    setRedirectState(listState.redirect);
    setErrorState(listState.error);
  }, []);

  useEffect(() => {
    //console.log(globalContext.user);
    updateDate(globalContext.user);
  }, [globalContext.user]);
  // eslint-disable-line react-hooks/exhaustive-deps

  /**
   * Evenet Submit form
   * @param Object event
   */
  const handleSubmit = async (event) => {
    let dataForm = new FormData(event.target.closest('form')),
        errorTemp = Object.assign({}, errorState),
        errorDetect = false,
        listInput = getInput(),
        data = Object.assign({}, globalContext.user);

    for (let property in globalContext.user) {// eslint-disable-line no-unused-vars
      let newValue = dataForm.get('input_' + property);
      if (newValue !== null) {
        data[property] = newValue;
        if( listInput[property].required == true ){
          errorTemp[property] = Utility.checkValue(listInput[property].name, newValue, listInput[property].typePattern);
          if(errorTemp[property].error === true) {
            errorDetect = true;
          }
        }
      }
    }
    setErrorState(errorTemp);
    updateDate(data);

    if (errorDetect === false) {
      //data = new URLSearchParams(data);
      //console.log(data)
      API.postForm(Utility.getUrlAjax()+'/updateUserAction', data)
      .then(response => {
        ResponseManagement(response,
          () => {
            updateDate(response.data.data.user);
            dispatch({ type: SET_USER, payload: response.data.data.user });
            props.handleChangePage('additionalInformation', 'after');

            if (response.data.message) {
              toast.success(response.data.message);
            }
          },
          () => { }
        );
      })
      .catch(error => {
        console.error(error)
        ErrorManagement(error, () => {});
      })
    } else {
      toast.error(globalContext.translations.msgErrorEnterAllInput);
    }
  }

  const getInput = () => {
    return {
      firstAddress: {
        name: 'firstAddress',
        //required: true,
        required: globalContext.fieldResidentParam.resident?.ad1 === "mandatory",
        typePattern: 'notNull',
        valueDefault: '',
        disabled: globalContext.fieldResidentParam.resident?.ad1 === "mandatory" && firstAddressState != '' ? props.hasBookingCheckInState.hasBookingCheckIn : false
      },
      secondaryAddress: {
        name: 'secondaryAddress',
        required: false,
        typePattern: false,
        valueDefault: ''
      },
      thirdAddress: {
        name: 'thirdAddress',
        required: false,
        typePattern: false,
        valueDefault: ''
      },
      zipCode: {
        name: 'zipCode',
        //required: true,
        required: globalContext.fieldResidentParam.resident?.cp === "mandatory",
        typePattern: 'notNull',
        valueDefault: '',
        disabled: globalContext.fieldResidentParam.resident?.cp === "mandatory" && zipCodeState != '' ? props.hasBookingCheckInState.hasBookingCheckIn : false
      },
      city: {
        name: 'city',
        //required: true,
        required: globalContext.fieldResidentParam.resident?.ville === "mandatory",
        typePattern: 'notNull',
        valueDefault: '',
        disabled: globalContext.fieldResidentParam.resident?.ville === "mandatory" && cityState != '' ? props.hasBookingCheckInState.hasBookingCheckIn : false
      },
      country: {
        name: 'country',
        //required: true,
        required: globalContext.fieldResidentParam.resident?.pays === "mandatory",
        typePattern: 'notNull',
        valueDefault: 0,
        disabled: globalContext.fieldResidentParam.resident?.pays === "mandatory" && countryState != '' && countryState != '00' && countryState != 0 ? props.hasBookingCheckInState.hasBookingCheckIn : false
      },
    }
  }

  const renderRedirectAccount = () => {
    if (redirectState) {
      return <Navigate to={Utility.getUrlPage(globalContext, 'additionalInformation')} />
    }
  }

  const updateDate = (data) => {
    let errorTemp = Object.assign({}, errorState);
    let listInput = getInput();


    for (let index in listInput) {// eslint-disable-line no-unused-vars
      let input = listInput[index]
      let theValue = data[input.name]

      if( input.required == true ){
        let test = Utility.checkValue(input.name, theValue, input.typePattern)
        //errorTemp[test.target] = test.error

        input.name = test.target
        theValue = test.value
      }

      switch (input.name) {
        case 'firstAddress':
          setFirstAddressState(theValue);
          break;
        case 'secondaryAddress':
          setSecondaryAddressState(theValue);
          break;
        case 'thirdAddress':
          setThirdAddressState(theValue);
          break;
        case 'zipCode':
          setZipCodeState(theValue);
          break;
        case 'city':
          setCityState(theValue);
          break;
        case 'country':
          setCountryState(theValue);
          break;
        default:
          break;
      }
      //setErrorState(errorTemp);
    }
  }

  const countries = [];

  if (Array.isArray(globalContext.countries) === true) {
    for (let i = 0; i < globalContext.countries.length; i++) {
      let { id, iso, name } = globalContext.countries[i],
          codeIso = Utility.lowerCase(iso);

      // pour drapeau non existant
      if (codeIso == 'bl' || codeIso == 'mf' ) {
        codeIso = 'fr'
      }
      else if (codeIso == 'sx' ) {
        codeIso = 'nl'
      }
      else if (codeIso == 'ss' ) {
        codeIso = 'sd'
      }

      if (Utility.testFlag(codeIso) === true) {
        countries.push({
          key: iso,
          text: [<Flag name={codeIso} key={id + 'Flag'} />, name],
          value: iso,
        });
      }
    }
  }

  let listInput = getInput();

  return (
    <Form id="form-address-cp">
      {renderRedirectAccount()}
      <Form.Group widths="equal">
        <InputText
          label={globalContext.translations.numberAndNameOfTheStreet}
          icon="home"
          iconPosition="left"
          name={listInput.firstAddress.name}
          value={firstAddressState}
          required={listInput.firstAddress.required}
          labelError={globalContext.translations.enterAddress}
          typePattern={listInput.firstAddress.typePattern}
          error={errorState.firstAddress}
          disabled={listInput.firstAddress.disabled}
        />

        <InputText
          label={globalContext.translations.buildingResidence}
          icon="building"
          iconPosition="left"
          name={listInput.secondaryAddress.name}
          value={secondaryAddressState}
        />
      </Form.Group>

      <Form.Group widths="equal">
        <InputText
          label={globalContext.translations.localityOrPostOfficeBox}
          icon="tag"
          iconPosition="left"
          name={listInput.thirdAddress.name}
          value={thirdAddressState}
        />

        <InputText
          label={globalContext.translations.postalCode}
          icon="mail"
          iconPosition="left"
          name={listInput.zipCode.name}
          value={zipCodeState}
          required={listInput.zipCode.required}
          labelError={globalContext.translations.enterCp}
          typePattern={listInput.zipCode.typePattern}
          error={errorState.zipCode}
          disabled={listInput.zipCode.disabled}
        />
      </Form.Group>

      <Form.Group widths="equal">
        <InputText
          label={globalContext.translations.city}
          icon="fort awesome"
          iconPosition="left"
          name={listInput.city.name}
          value={cityState}
          required={listInput.city.required}
          labelError={globalContext.translations.enterVille}
          typePattern={listInput.city.typePattern}
          error={errorState.city}
          disabled={listInput.city.disabled}
        />

        <InputSelect
          label={globalContext.translations.countryOfResidence}
          name={listInput.country.name}
          value={countryState}
          data={countries}
          required={listInput.country.required}
          labelError={globalContext.translations.enterVille}
          typePattern={listInput.country.typePattern}
          error={errorState.country?.error}
          search={!isMobile}
          disabled={listInput.country.disabled}
        />
      </Form.Group>

      <Form.Field className="mt-5">
        <Button
          positive
          className="mx-auto d-block"
          content={globalContext.translations.next}
          icon="right arrow"
          labelPosition="right"
          onClick={handleSubmit}
        />
      </Form.Field>
    </Form>
  );
}

export default FormAddressCP;